import React from 'react';
import './go-to-top.css';

class GoToTop extends React.Component {

  sendGoToTopEvent = () => {
      if(window.location.hostname === 'localhost' || window.location.hostname.indexOf('192.168.0') === 0) {
          return;
      }

      fetch('https://09mclyfv7k.execute-api.eu-central-1.amazonaws.com/prod/log_event', {
          method: 'POST',
          headers: {
              "Content-Type": "application/json",
          },
          body: JSON.stringify({type: 'go-to-top', name: 'binaryfusion.ro', from: '-'}),
      }).then((response) => response.json().then((responseData) => {
          sessionStorage.setItem('success', responseData.EventId);
      }));
  }

  scrollToTop() {
    this.sendGoToTopEvent();
    window.scrollTo(0,0);
  }

  render() {
    return (
      <div id='gtt-back' onClick={() => this.scrollToTop()} >
        <div id='gtt-front' />
      </div>
    );
  }
}

export default GoToTop;